import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/duihao.png';
import _imports_1 from '@/assets/12345.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1b5665d6"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "w100% min-w-1200px bg-#e9f3ff pt-90px pb-90px"
};
var _hoisted_2 = {
  "class": "e-cont"
};
var _hoisted_3 = {
  "class": "w-550px"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "font-size-28px color-#225eef font-600"
  }, "对接案例", -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "divider pos-relative"
  }, [/*#__PURE__*/_createElementVNode("div", {
    "class": "w-26px h-3px bg-black pos-absolute left-0 bottom-0"
  })], -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "font-size-22px color-#121212"
  }, "唐山市12345政务服务便民热线新系统", -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    "class": "h22px w-auto mr-10px"
  }, null, -1);
});
var _hoisted_8 = {
  "class": "color-#333333"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    "class": "w550px h-auto"
  }, null, -1);
});
export default {
  __name: 'indexExample',
  setup: function setup(__props) {
    var introduction = ['全新开发12345热线智能服务平台', '成功对接热力、燃气、自来水等多个民生系统', '对接各级政府部门业务办理系统'];
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _hoisted_6, _createElementVNode("div", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(introduction, function (v, i) {
        return _createElementVNode("div", {
          key: i,
          "class": "flex flex-items-center mt-15px"
        }, [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString(v), 1)]);
      }), 64))])]), _hoisted_9])]);
    };
  }
};